const redirectToGeneral = ({ returnAfterLogin = false }) => {
  const path = returnAfterLogin
    ? `/?redirect=${window.location.href}`
    : '/#/select';
  window.location.replace(
    `${process.env.WEB_AUTH_URL || 'https://general.aula.education'}${path}`
  );
};

export default redirectToGeneral;
